/**
 * Client-generated ids. Clips are created optimistically and the id travels
 * with the operation, so it has to be unique across everyone editing at once --
 * hence a random suffix rather than a counter.
 */
export function newId(prefix: string): string {
  const random =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID().slice(0, 8)
      : Math.random().toString(36).slice(2, 10);
  return `${prefix}_${random}`;
}
